import { ReactElement, ReactNode } from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export interface IModalProps extends DialogProps {
  open: boolean;
  isCloseOutsideClicked?: boolean;
  children: ReactElement;
  title?: string;
  subtitle?: ReactNode;
  onClose?: () => void;
}

export const Modal: React.FC<IModalProps> = (props) => {
  const { open, title, subtitle, children, onClose, isCloseOutsideClicked, ...others } = props;

  return (
    <Dialog open={open} onClose={isCloseOutsideClicked ? onClose : undefined} {...others}>
      {title && (
        <DialogTitle>
          <div>
            <span className='text-24 xl:text-26 font-bold leading-20 xl:leading-24 pt-8 block'>{title}</span>
            {subtitle && <div className='text-14 xl:text-16 text-neutral-70 mt-2'>{subtitle}</div>}
          </div>

          {onClose ? (
            <IconButton
              aria-label='close'
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
